import { render, staticRenderFns } from "./LegislativeProposalsConsult.vue?vue&type=template&id=a1da8780&scoped=true"
import script from "./LegislativeProposalsConsult.vue?vue&type=script&lang=js"
export * from "./LegislativeProposalsConsult.vue?vue&type=script&lang=js"
import style0 from "./LegislativeProposalsConsult.vue?vue&type=style&index=0&id=a1da8780&prod&lang=css"
import style1 from "./LegislativeProposalsConsult.vue?vue&type=style&index=1&id=a1da8780&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1da8780",
  null
  
)

export default component.exports